import { Page } from "@/models/page-models/Page";

export const ClosedQuotations: Page = {
  "path": "closed-quotations",
  "name": "Closed Quotations",
  "props": {
    "data":{
      "title": "Closed Quotations",
      "printable": "FALSE",
      "url": "closed-quotations",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "datepicker",
                  "variable": "formData.from",
                  "label": "Select Start Date",
                  "disabled": "FALSE"
                },
                {
                  "type": "datepicker",
                  "variable": "formData.to",
                  "label": "Select End Date",
                  "disabled": "FALSE"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.groups",
                  "label": "Select Group",
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager))",
                  "items": "fetchedData.customerGroups.data",
                  "itemText": "name",
                  "itemValue": "_id",
                  "multiple": true
                },
                {
                  "type": "button",
                  "label": "Update",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "getClosedQuotationReport",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/quotation/closed-quotations",
                        "arg2Key": "storeInVar",
                        "arg2Value": "fetchedData.closedQtValues",
                        "arg3Key": "postData",
                        "arg3Value": "formData"
                      },
                      "name": "getClosedQuotationReport"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "salesFunnel",
                  "showIf": "{{fetchedData.closedQtValues.data}}",
                  "salesFunnelVariable": "fetchedData.closedQtValues.data",
                  "funnelType": "Closed"
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyQueryParams",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getQueryParams",
          "arg2Key": "destinationKey",
          "arg2Value": "formData",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyQueryParams"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getClosedQuotationReport",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/quotation/closed-quotations",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.closedQtValues",
          "arg3Key": "postData",
          "arg3Value": "formData"
        },
        "name": "getClosedQuotationReport"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getCustomerGroups",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/businesspartnergroups",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customerGroups"
        },
        "name": "getCustomerGroups",
        "executeIf": "fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager))"
      }
    ],
    "functions": [
      {
        "name": "getQueryParams",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "from": "{{MONTH_START}}",
          "to": "{{TODAYS_DATE}}"
        },
        "useFormula": true
      }
    ]
  },
  "forRole": "SALES_MANAGER,SALES_ACCOUNT_EXECUTIVE,GENERAL_MANAGER",
  "visible": true,
  "routerPriority": 30,
  "menuGroup": "Reports"
}